<template>
    <v-container>
      <v-calendar view="month"></v-calendar>
    </v-container>
  </template>